import React from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import Header from './Header.js';

export default function Settings() {
  const [apiToken, setApiToken] = React.useState();
  const [showToken, setShowToken] = React.useState(false);

  React.useEffect(() => {
    async function doit() {
      const response = await fetch('/api/token', {method: 'GET'});
      const data = await response.json();
      setApiToken(data.token);
    }

    doit();
  });

  const requestToken = async () => {
    const response = await fetch('/api/token', {method: 'POST'});
    const data = await response.json();
    setApiToken(data.token);
  };

  const revokeToken = async () => {
    const response = await fetch('/api/token', {method: 'DELETE'});
    const data = await response.json();
    setApiToken(data.token);
  };

  const toggleShowToken = () => {
    setShowToken(!showToken);
  };

  return (
    <>
      <Header title="Settings" location="/settings" />
      <div className="card">
        <h5>API Access</h5>
        {apiToken ?
          <div>
            <Container style={{'margin-bottom': '10px'}}>
              <Row>
                <Col sm="auto" style={{'margin-top': '8px'}}>Your API Token:</Col>
                <Col><Form.Control type={showToken ? 'text' : 'password'} value={apiToken} readOnly /></Col>
                <Col sm="auto"><Button variant="secondary" onClick={toggleShowToken}>{showToken ? "Hide" : "Show"}</Button></Col>
              </Row>
            </Container>
            <Button onClick={revokeToken}>Revoke Token</Button>
          </div>
        :
          <div>
            <p>You do not have an API token assigned.</p>
            <Button onClick={requestToken}>Request a Token</Button>
          </div>
        }
      </div>
    </>
  );
};
